import { useLanguage } from "../contexts/LanguageContext";
import { Globe } from "lucide-react";

const LanguageSwitcher = ({ className = "" }) => {
  const { language, changeLanguage } = useLanguage();

  return (
    <button
      onClick={() => changeLanguage(language === "tr" ? "en" : "tr")}
      className={`flex items-center gap-2 px-3 py-1.5 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-primary/50 transition-all font-mono text-sm ${className}`}
      title={language === "tr" ? "Switch to English" : "Türkçe'ye geç"}
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase font-bold">{language.toUpperCase()}</span>
    </button>
  );
};

export default LanguageSwitcher;
